/**
 * Format a currency amount with the appropriate symbol and locale.
 *
 * @param {number|string} amount - The numeric amount to format
 * @param {string} [symbol] - Currency symbol (e.g. "$", "€", "₹")
 * @param {string} [locale='en-IN'] - Locale for number formatting
 * @returns {string} Formatted currency string, e.g. "₹ 1,234.00"
 */
export function formatCurrency(amount, symbol, locale = 'en-IN') {
  const num = parseFloat(amount) || 0;
  const formatted = num.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const currencySymbol = symbol || getDefaultCurrencySymbol();
  return `${currencySymbol} ${formatted}`;
}

/**
 * Get the default currency symbol from the current organization's settings.
 * Falls back to "₹" if nothing is configured.
 */
export function getDefaultCurrencySymbol() {
  try {
    const stored = localStorage.getItem('orgDefaultCurrencySymbol');
    if (stored) return stored;
  } catch {
    // localStorage may not be available
  }
  return '₹';
}

/**
 * Set the default currency symbol for the current organization.
 * Call this when organization data loads.
 */
export function setDefaultCurrencySymbol(symbol) {
  try {
    if (symbol) {
      localStorage.setItem('orgDefaultCurrencySymbol', symbol);
    }
  } catch {
    // localStorage may not be available
  }
}

/**
 * Get currency symbol from a row's tax_account or fall back to org default.
 */
export function getCurrencySymbol(row) {
  return row?.tax_account?.default_currency?.symbol || getDefaultCurrencySymbol();
}
